import { render } from "./MiniWizardStickyCredits.vue?vue&type=template&id=e073bd04"
import script from "./MiniWizardStickyCredits.vue?vue&type=script&lang=js"
export * from "./MiniWizardStickyCredits.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__